interface StringMatch {
  equals?: string;
  in?: { values?: string[] };
}

interface ReferenceFilter {
  key?: StringMatch;
  value?: StringMatch & { not?: boolean };
}

export interface SuppressionReferenceFilter {
  filters?: ReferenceFilter[];
}

function matchesReferenceKey(filter: ReferenceFilter, keys: string[]): boolean {
  const filterKeys = filter.key?.equals ? [filter.key.equals] : filter.key?.in?.values || [];
  return keys.some((key) => filterKeys.includes(key));
}

export function getSuppressionReferenceIds(
  keyFilter: SuppressionReferenceFilter | undefined,
  keys: string[]
): string[] {
  return [
    ...new Set(
      (keyFilter?.filters || []).flatMap((filter) => {
        if (filter.value?.not || !matchesReferenceKey(filter, keys)) {
          return [];
        }

        return filter.value?.equals !== undefined ? [filter.value.equals] : filter.value?.in?.values || [];
      })
    )
  ];
}
